import React, { useId } from 'react'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import IconButton from '@mui/material/IconButton'
import Popover from '@mui/material/Popover'
import CloseIcon from '@mui/icons-material/Close'
import DropdownSelect from '../../pages/components/DropdownSelect'

export const PopoverSelector = ({
    anchorEl,
    label,
    onChange,
    onClose,
    options,
    selectedId,
}: {
    anchorEl: Element
    label: string
    onChange: () => void
    onClose: () => void
    options: Array<{ id: string; label: string }>
    selectedId: string
}) => {
    const popoverId = useId()

    return (
        <Popover
            id={popoverId}
            open={!!anchorEl}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
        >
            <Card>
                <CardHeader
                    action={
                        <IconButton disableRipple onClick={onClose}>
                            <CloseIcon />
                        </IconButton>
                    }
                    subheader={label}
                />
                <Box
                    sx={{
                        px: 4,
                        pb: 4,
                    }}
                >
                    <DropdownSelect items={options} selectedItems={selectedId} onChange={onChange} />
                </Box>
            </Card>
        </Popover>
    )
}
